<template>
  <button
    type="button"
    class="inline-flex items-center justify-center w-full text-sm font-medium px-4 py-2 border border-slate-300 rounded-lg bg-white shadow gap-x-2.5 active:bg-slate-50 active:shadow-sm transition"
  >
    <slot />
  </button>
</template>
